<template>
  <Page class="page-container--scrollable-table">
    <PageContent>
      <template v-if="selectedOrganization?.resource.type === 'user'">
        <AddressContext>
          <OrganizationPersonal />
        </AddressContext>
      </template>
      <template
        v-else-if="
          selectedOrganization?.resource.verification?.state === 'none' ||
          selectedOrganization?.resource.verification?.state === 'pending'
        "
      >
        <OrganizationNotVerified />
      </template>

      <OrganizationContext v-else>
        <AddressContext>
          <DomainVerificationContext>
            <OrganizationTabs>
              <RouterView />
            </OrganizationTabs>
          </DomainVerificationContext>
        </AddressContext>
      </OrganizationContext>
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import AddressContext from '@/components/deepadmin/address/AddressContext.vue'
import DomainVerificationContext from '@/components/deepadmin/domain-verifications/DomainVerificationContext.vue'
import OrganizationContext from '@/components/deepadmin/organization/OrganizationContext.vue'
import OrganizationNotVerified from '@/components/deepadmin/organization/OrganizationNotVerified.vue'
import OrganizationPersonal from '@/components/deepadmin/organization/OrganizationPersonal.vue'
import OrganizationTabs from '@/components/deepadmin/organization/OrganizationTabs.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

const { selectedOrganization } = useAccountMembershipsContext()

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.organization.settings.title',
  },
})
</script>
